import WebsiteTable from "../Website/WebsiteTable";
import React, { useEffect } from "react";
import Sidebar from "../Side/Sidebar";
import Topbar from "../Side/Topbar";
import AdminSidebar from "../Side/AdminSidebar";
import { useAuth } from "../Auth/AuthContext"; // Import useAuth
import AddWebsiteForm from "../Website/AddWebsiteForm";

const Webistes = () => {
    const { authState } = useAuth(); // Get authState from AuthContext
        const role = authState.roles;
        const admin = role === "Admin";
    return (
        <div className="min-h-screen flex flex-col md:flex-row">
            {/* Sidebar */}
            {admin ? <AdminSidebar /> : <Sidebar />}

            {/* Main Content */}
            <div className="flex-1 bg-gray-100">
                <div className="flex-1 flex flex-col">
                    <Topbar />

                    {/* Main Content */}
                    <main className="pt-[60px] px-4">
                        <div className="mt-6">
                            {/* <AddWebsiteForm /> */}
                            <WebsiteTable />
                        </div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default Webistes;
